import * as React from "react";
function SvgFullscreenExit(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <g clipPath="url(#fullscreen-exit_svg__clip0_1347_7099)">
                <path
                    d="M5.293 16h3v3h2v-5h-5v2zm3-8h-3v2h5V5h-2v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
                    fill="currentcolor"
                />
            </g>
            <defs>
                <clipPath id="fullscreen-exit_svg__clip0_1347_7099">
                    <path
                        fill="#fff"
                        transform="translate(.293)"
                        d="M0 0h24v24H0z"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgFullscreenExit);
export default ForwardRef;
